import { Individual } from '../types/interface';

export const repsonsiveBreakPoints = {
  values: {
    xs: 300, // max-width small mobile
    sm: 768, //max-width mobile
    md: 1025, //max-width tablet
    lg: 1200, //max-width laptop
    xl: 1400, //min-width xlLaptop
  },
};

export const SCHEDULE_OPTIONS = [
  { value: 0, text: 'Monday', abbr: 'Mon' },
  { value: 1, text: 'Tuesday', abbr: 'Tue' },
  { value: 2, text: 'Wednesday', abbr: 'Wed' },
  { value: 3, text: 'Thursday', abbr: 'Thu' },
  { value: 4, text: 'Friday', abbr: 'Fri' },
  { value: 5, text: 'Saturday', abbr: 'Sat' },
  { value: 6, text: 'Sunday', abbr: 'Sun' },
  { value: 7, text: 'Rotating', abbr: 'Rotation' },
];

export const NOTIFICATION = {
  B2C_JOB_CLOSE_SOON: 'B2C_LIKED_EJI_JOB_CLOSE_REMINDER',
  B2C_JOB_REOPEN: 'B2C_LIKED_EJI_JOB_OPEN_REMINDER',
  B2C_INDIV_MATCH: 'B2C_INDIVIDUAL_MATCH',
  B2C_INDIV_UPDATED: 'B2C_INDIVIDUAL_UPDATE',
  B2C_EJI_NOT_A_MATCH: 'B2C_EJI_NOT_A_MATCH',
  B2C_EJI_UPDATED: 'B2C_EJI_UPDATED',
  B2C_EJI_OFFER: 'B2C_EJI_OFFER',
};

export const PROPERTY_DICT: any = {
  id: 'id',
  profileImg: 'img',
  leadProviderOrgId: 'organiziation',
  firstName: 'first name',
  lastName: 'last name',
  pronouns: 'pronouns',
  agencyId: 'agency id',
  govId: 'government id',
  intakeDate: 'start date',
  preferredComms: 'preferred communication',
  requiredAccommodation: 'accomodations',
  email: 'profile email',
  leadProviderId: 'provider ID',
  leadProviderName: 'provider',
  address: 'address',
  phone: 'phone number',
  dob: 'birth date',
  policeCheck: 'police check date',
  creditCheck: 'credit check date',
  preferredRoles: 'preferred roles',
  minRate: 'min hourly rate',
  maxRate: 'max hourly rate',
  fileAttachments: 'file attachments',
  referenceAttachments: 'reference attachments',
  certificationAttachments: 'certification attachments',
  skills: 'skills',
  interests: 'interests',
  restrictions: 'restrictions',
  restrictionsText: 'restrictions',
  status: 'Job search status',
  daysAvailable: 'available days',
  availableHours: 'available hours',
  filledHours: 'filled hours',
  employmentRecord: 'employment record',
  employmentHistory: 'employment history record',
  notes: 'notes',
  longitude: 'longitude',
  latitude: 'latitude',
};

export enum Sort {
  Default = 'createdAt',
  CloseDate = 'closeDate',
  MinRate = 'minRate',
  TotalHours = 'totalHrs',
  Distance = 'distance',
}

export enum FilterType {
  MinRate = 'minRate',
  DaysAvailable = 'availDay',
  HrsPerWeek = 'hrsPerWeek',
}

export enum APPLICATION_STATUS {
  PROCESSING = 'In Progress',
  INTERVIEWING = 'Interview Scheduled',
  OFFER = 'Offer of Employment',
  NOPE = 'Not a Match',
}

export enum ButtonMyJob {
  Matches = 'matches',
  Applications = 'interests',
  Likes = 'likes',
}

export const is14YearsInMilliseconds = (14 * 365 + 3) * 24 * 60 * 60 * 1000;

export const regXPhoneNumber = /^(?:1-)?\d{3}(?:[-.]\d{3})?[-.]\d{4}(?: ext\. \d{1,5})?$/i;

export const regXEmail = /^\w+([\.-]?\w+)*(\+\w+)?@\w+([\.-]?\w+)*(\.\w{2,10})+$/i;
